import ApprovalUnifiedEventStepContent from './ApprovalUnifiedEventStepContent';
import ApprovalUnifiedEventTimestamp from './ApprovalUnifiedEventTimestamp';
import ApprovalUnifiedEventNote from './ApprovalUnifiedEventNote';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalUnifiedEventConcludedI18n } from '../i18n/ApprovalUnifiedEventI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ApprovalUnifiedEventConcluded(props) {
  const {
    event
  } = props;
  const {
    meta
  } = useApprovalContext();
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "approval-unified-event-concluded",
    children: /*#__PURE__*/_jsxs(ApprovalUnifiedEventStepContent, {
      children: [/*#__PURE__*/_jsx(ApprovalUnifiedEventConcludedI18n, {
        approvalAction: meta.approvalAction,
        event: event
      }), /*#__PURE__*/_jsx(ApprovalUnifiedEventTimestamp, {
        event: event
      }), /*#__PURE__*/_jsx(ApprovalUnifiedEventNote, {
        event: event
      })]
    })
  });
}